import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Popover
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { SketchPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addClima, updateClima } from "../../Services/ClimaService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      displayColorPicker: false,

      estados: [],
      checkboxEstados: [],
      checkboxEstadosSelected: [],
      climaCidade: [],
      checkboxCidades: [],
      checkboxCidadesSelected: [],
      data: {
        id: '',
        name: '',
        description: '',
        descriptionPlural: '',
        bibliografia: '',
        color: '#87CEFA',
        colorRGB: {r: 135, g: 206, b: 250, a: 1},
        status: '',
        deleted: '',
        createdAt: '',
        updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      let rgb = JSON.stringify(data['colorRGB']);
      data['colorRGB'] = rgb;

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        clima: data,
        climaEstadoList: this.getClimaEstado(),
        climaCidadeList: this.getClimaCidade()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        addClima(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear();              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateClima(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    if(data.color === undefined || data.color === null || data.color === ''){
      this.show('danger', this.props.t('forms.requiredFieldColor'));
      validated = false;
    }

    if(data.description === undefined || data.description === null || data.description === ''){
      this.show('danger', this.props.t('forms.requiredFieldDescription'));
      validated = false;
    }

    if(data.descriptionPlural === undefined || data.descriptionPlural === null || data.descriptionPlural === ''){
      this.show('danger', this.props.t('forms.requiredFieldDescriptionPlural'));
      validated = false;
    }

    if(data.bibliografia === undefined || data.bibliografia === null || data.bibliografia === ''){
      this.show('danger', this.props.t('forms.requiredFieldBibliografia'));
      validated = false;
    }

    return validated;  
  }

  getClimaEstado() {
    let climaEstado = [];
    if(this.state.checkboxEstadosSelected.length > 0){
      for(let j = 0; j < this.state.checkboxEstadosSelected.length; j++){
        for(let i = 0; i < this.state.estados.length; i++){
          if(this.state.checkboxEstadosSelected[j].value === this.state.estados[i].id){
            climaEstado.push( {estado: this.state.estados[i]} );
            break;
          }
        }
      }
    }
    return climaEstado;
  }

  getClimaCidade() {
    let climaCidade = [];
    let cidades = [];
    let cidadeEncontrada = false;
    if(this.state.checkboxCidadesSelected.length > 0){
      for(let j = 0; j < this.state.checkboxCidadesSelected.length; j++){
        cidadeEncontrada = false;
        for(let e = 0; e < this.state.estados.length; e++){
          cidades = this.state.estados[e].cidades;
          for(let i = 0; i < cidades.length; i++){
            if(this.state.checkboxCidadesSelected[j].value === cidades[i].id){
              climaCidade.push( {cidade: cidades[i]} );
              cidadeEncontrada = true;
              break;
            }
          }
          if(cidadeEncontrada){
            break;
          }
        }
      }
    }
    return climaCidade;
  }

  loadData(selected, estados, climaEstado, climaCidade) {
    let options = [];
    let optionsC = [];
    let optionsSelected = [];
    let optionsSelectedC = [];
    let cidades = [];
    let climaCidadeList = [];
    let obj = {};
    let objC = {};
    if(climaCidade !== undefined && climaCidade !== null && climaCidade.length > 0 ){
      climaCidadeList = climaCidade;
    }
    if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
      if(climaEstado !== undefined && climaEstado !== null && climaEstado.length > 0){
        for(let i = 0; i < estados.length; i++){
          obj = {value:estados[i].id, label: estados[i].name, uf: estados[i].uf, checked: false, checkedAll: false};
          for(let j = 0; j < climaEstado.length; j++){
            if(estados[i].id === climaEstado[j].estado.id){
              obj.checked = true;
              optionsSelected.push(obj);
              cidades = estados[i].cidades;

              for(let i2 = 0; i2 < cidades.length; i2++){
                objC = {value:cidades[i2].id, label: estados[i].uf + " - " + cidades[i2].name, uf: estados[i].uf, checked: false};
                for(let j2 = 0; j2 < climaCidadeList.length; j2++){
                  if(cidades[i2].id === climaCidadeList[j2].cidade.id){
                    objC.checked = true;
                    optionsSelectedC.push(objC);
                    break;
                  }
                }
                optionsC.push(objC);
              }
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < estados.length; i++){
          options.push({value:estados[i].id, label: estados[i].name, uf: estados[i].uf, checked: false, checkedAll: false});
        }
      }
      
      this.setState({ 
        checkboxEstados: options,
        checkboxEstadosSelected: optionsSelected,
        estados: estados,
        checkboxCidades: optionsC, 
        checkboxCidadesSelected: optionsSelectedC,
        climaCidade: climaCidade,
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, estados, climaEstado, climaCidade } = this.props;
    this.loadData(selected, estados, climaEstado, climaCidade);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.estados !== this.props.estados || 
        props.climaEstado !== this.props.climaEstado || props.climaCidade !== this.props.climaCidade){
      this.loadData(this.props.selected, this.props.estados, this.props.climaEstado, this.props.climaCidade);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }
  
  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value;
    this.setState({ data });
  }

  updateCheckboxEstado(event) {
    let selecteds = [];
    let objC = {};
    let cidades = [];
    let optionsC = [];
    let optionsSelectedC = [];

    event.checked = !event.checked;
    if(this.state.checkboxEstadosSelected.length > 0){
      for(let i = 0; i < this.state.checkboxEstadosSelected.length; i++){
        if(this.state.checkboxEstadosSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxEstadosSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }

    for(let i = 0; i < selecteds.length; i++){
      for(let j = 0; j < this.state.estados.length; j++){
        if(selecteds[i].value === this.state.estados[j].id){
          cidades = this.state.estados[j].cidades;

          for(let i2 = 0; i2 < cidades.length; i2++){
            objC = {value:cidades[i2].id, label: this.state.estados[j].uf + " - " + cidades[i2].name, uf: this.state.estados[j].uf, checked: false};
            for(let j2 = 0; j2 < this.state.checkboxCidadesSelected.length; j2++){
              if(cidades[i2].id === this.state.checkboxCidadesSelected[j2].value){
                objC.checked = true;
                optionsSelectedC.push(objC);
                break;
              }
            }
            optionsC.push(objC);
          }
        }
      }
    }

    this.setState({ 
      checkboxEstadosSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1),
      checkboxCidades: optionsC.sort((a, b) => (a.label > b.label) ? 1 : -1), 
      checkboxCidadesSelected: optionsSelectedC.sort((a, b) => (a.label > b.label) ? 1 : -1) 
    });
  }
  

  updateCheckboxCidadeAll(event){
    let selecteds = [];
    let item = {};
    event.checkedAll = !event.checkedAll;
    if(this.state.checkboxCidades.length > 0){
      for(let i = 0; i < this.state.checkboxCidades.length; i++){
        item = this.state.checkboxCidades[i];
        if(item.uf === event.uf){
          item.checked = event.checkedAll;
        }
        if(item.checked){
          selecteds.push(item);
        }
      }
    }
    this.setState({ 
      checkboxCidadesSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1) 
    });
  }


  updateCheckboxCidade(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxCidadesSelected.length > 0){
      for(let i = 0; i < this.state.checkboxCidadesSelected.length; i++){
        if(this.state.checkboxCidadesSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxCidadesSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ 
      checkboxCidadesSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1)  
    });
  }

  clear(){
    console.log("clear edit");
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['description'] = '';
    data['descriptionPlural'] = false;
    data['bibliografia'] = '';
    data['color'] = '#87CEFA';
    data['colorRGB'] = {r: 135, g: 206, b: 250, a: 1};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data,
      checkboxEstadosSelected: [],
      checkboxCidadesSelected: [],
      checkboxCidades: [],
      active: false,
      displayColorPicker: false
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ displayColorPicker: !prevState.displayColorPicker, active: !prevState.active }));
  };

  handleChange = (color) => {
    const data = { ...this.state.data }
    data['color'] = color.hex;
    data['colorRGB'] = color.rgb;
    this.setState({ data });
  };

  render() {
    const { t } = this.props;
    const { data, active, displayColorPicker } = this.state;
    const color = data.color;
    const rgb = data.colorRGB;
    
    let notOK = !hasAccess("MENU_CLIMATE_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesEstadosAll = [];
    let checkboxesEstados = [];
    let checkboxesCidades = [];
    let checked = false;

    let total = this.state.checkboxEstados.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checked = false;
        if(this.state.checkboxEstadosSelected.includes(this.state.checkboxEstados[i])){
          checked = true;
          checkboxesEstadosAll.push(
            <div key={"divestadosAll_"+this.state.checkboxEstados[i].value} className='form__form-inline' style={{width: '60px'}}>
              <input type="checkbox" 
                id={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                name={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                style={{float: 'left', width: '30px', height: '18px'}}
                onChange={e => this.updateCheckboxCidadeAll(this.state.checkboxEstados[i])}
                checked={this.state.checkboxEstados[i].checkedAll} 
              />
                <label 
                  key={"labelestadosAll_"+this.state.checkboxEstados[i].value}
                  htmlFor={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                  style={{margin: 0, height: '25px'}}>
                  {this.state.checkboxEstados[i].uf}
                </label>
            </div>
          );
        }
        checkboxesEstados.push(
          <div key={"divestados_"+this.state.checkboxEstados[i].value} className='form__form-inline' style={{width: '170px'}}>
            <input type="checkbox" 
              id={"checkboxestados_"+this.state.checkboxEstados[i].value} 
              name={"checkboxestados_"+this.state.checkboxEstados[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxEstado(this.state.checkboxEstados[i])}
              checked={checked} 
            />
              <label 
                key={"labelestados_"+this.state.checkboxEstados[i].value}
                htmlFor={"checkboxestados_"+this.state.checkboxEstados[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxEstados[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxCidades.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesCidades.push(
          <div key={"divcidades_"+this.state.checkboxCidades[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
              name={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxCidade(this.state.checkboxCidades[i])}
              checked={this.state.checkboxCidadesSelected.includes(this.state.checkboxCidades[i])} 
            />
              <label 
                key={"labelcidades_"+this.state.checkboxCidades[i].value}
                htmlFor={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxCidades[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.color')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <div className="color-picker">
                      <button
                        type="button"
                        className={`color-picker__button${active ? ' active' : ''}`}
                        onClick={this.handleClick}
                        id="color"
                      >
                        <p className="color-picker__color">{color}</p>
                        <div className="color-picker__color-view" style={{ backgroundColor: color }} />
                      </button>
                      <Popover
                        isOpen={displayColorPicker}
                        target="color"
                        placement="bottom"
                        className="color-picker__popover"
                      >
                        <SketchPicker
                          color={rgb}
                          onChange={e => this.handleChange(e)}
                        />
                      </Popover>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.estado_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesEstados}

                </div>
              </div>
              <div className="form__form-group">
                <div style={{float: 'left', marginRight: '5px'}}>
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.cidade_form.title')} 
                  </span>
                </div>
                <div style={{float: 'left'}}>
                {checkboxesEstadosAll}
                </div>
                <div className="form__form-group-field" 
                  style={{clear: 'both', border: '1px solid #CCCCCC', height: '400px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesCidades}

                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.description')} {t('forms.descriptionUmaCidade')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="description"
                    value={this.state.data.description || ""}
                    style={{width: "100%", height: "25px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.description')} {t('forms.descriptionMultiCidade1')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="descriptionPlural"
                    value={this.state.data.descriptionPlural || ""}
                    style={{width: "100%", height: "25px"}}
                    onChange={e => this.updateField(e)}
                    placeholder={t('forms.descriptionMultiCidade2')}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.bibliografia')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="bibliografia"
                    value={this.state.data.bibliografia || ""}
                    style={{width: "100%", height: "25px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>
              <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.status')}
                  </span>
                  <div className="form__form-group-field">
                    <label className="radio-btn">
                      <input className="radio-btn__radio"
                        name="status"
                        type="radio"
                        value={t('forms.ativo')}
                        onChange={e => this.updateField(e)}
                        checked={this.state.data.status === 'ATIVO' ? true : false}
                      />
                      <span className="radio-btn__radio-custom"></span>
                      <span className="radio-btn__label">{t('forms.ativo')}</span>
                    </label>
                    <label className="radio-btn">
                      <input className="radio-btn__radio"
                        name="status"
                        type="radio"
                        value={t('forms.inativo')}
                        onChange={e => this.updateField(e)}
                        checked={this.state.data.status === 'INATIVO' ? true : false}
                      />
                      <span className="radio-btn__radio-custom"></span>
                      <span className="radio-btn__label">{t('forms.inativo')}</span>
                    </label>
                  </div>
                </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'climaEdit', 
})(withTranslation('common')(CrudEdit));
